import React from 'react'
import CategoryField from './category_field'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Message } from '@bitcine/cinesend-theme/dist'
import { MISSING_UNIQUE_NAME } from '../../../constants/category_display'

const AssignedCategories = ({
  availableCategories,
  availablePreroll,
  availableWarningSlates,
  categories,
  assetID,
  cycleID,
  issue,
  assetType,
  isWarningSlate,
  isPrerollAd,
}) => {
  const params = useParams()
  const lang = params['*']
  const { data: languages } = useQuery(['/api/languages'])
  const langID = languages?.find((v) => v.ife_code === lang)?.id

  // Episodes and tracks inherit categories from their parent; only prerolls can be set on episodes
  const showCategories = !['ad', 'episode', 'track'].includes(assetType)

  const warningSlateCategories = categories.filter((cat) => ['warning-slates'].includes(cat.type))
  const prerollCategories = categories.filter((cat) => ['ad-pools'].includes(cat.type))

  const getTitle = (category) => {
    if (['warning-slates', 'featured-content'].includes(category.type)) {
      return (
        category.category_values?.find((v) => v.language_id === langID)?.value ||
        category.category_values?.[0]?.value ||
        ''
      )
    }
    return category.external_unique_name || MISSING_UNIQUE_NAME
  }

  const getCategoryValues = (category) => {
    const categoriesValue = []

    category.child_categories.map((item) => {
      const cat = mapCategoryToValue(item)
      if (cat) {
        categoriesValue.push(cat)
      }
    })
    return categoriesValue
  }

  const mapCategoryToValue = (category) => {
    const cat = categories.find((cat) => cat.id === category.id)
    if (!cat) {
      return null
    }

    return { label: getTitle(cat), value: cat.id }
  }

  return (
    <div>
      {showCategories && availableCategories.length > 0 && <p className='py-2'>Categories</p>}
      {issue && (
        <Message error={true} small={true}>
          {issue?.description}
        </Message>
      )}
      {!['ad', 'featured-content'].includes(assetType) && (
        <>
          {showCategories &&
            availableCategories.map((category) => (
              <CategoryField
                title={getTitle(category)}
                options={category.child_categories}
                value={getCategoryValues(category)}
                key={category.id}
                assetID={assetID}
                cycleID={cycleID}
                langID={langID}
                type='assets'
              />
            ))}

          {['movie', 'episode', 'series'].includes(assetType) && (
            <>
              <p className='py-2'>Prerolls</p>
              <CategoryField
                title='Warning Slate Group'
                options={availableWarningSlates}
                value={warningSlateCategories.map(mapCategoryToValue)}
                key='warning-slates'
                assetID={assetID}
                cycleID={cycleID}
                langID={langID}
                type='warning-slates'
              />
              <CategoryField
                title='Ad Pools'
                options={availablePreroll}
                value={prerollCategories.map(mapCategoryToValue)}
                key='prerolls'
                assetID={assetID}
                cycleID={cycleID}
                langID={langID}
                type='ad-pools'
              />
            </>
          )}
        </>
      )}
      {assetType === 'ad' && isWarningSlate && (
        <CategoryField
          title='Warning Slate Groups'
          options={availableWarningSlates}
          value={warningSlateCategories.map(mapCategoryToValue)}
          key='warning-slates'
          assetID={assetID}
          cycleID={cycleID}
          langID={langID}
          type='warning-slates'
          isMulti={true}
        />
      )}
      {assetType === 'ad' && isPrerollAd && (
        <CategoryField
          title='Ad Pools'
          options={availablePreroll}
          value={prerollCategories.map(mapCategoryToValue)}
          key='ad-pools'
          assetID={assetID}
          cycleID={cycleID}
          langID={langID}
          type='ad-pools'
          isMulti={true}
        />
      )}
      {assetType === 'featured-content' && (
        <CategoryField
          title='Section'
          options={availableCategories}
          value={categories.map(mapCategoryToValue)}
          key='featured-content'
          assetID={assetID}
          cycleID={cycleID}
          langID={langID}
          type='featured-content'
          disabled
        />
      )}
    </div>
  )
}

export default AssignedCategories
